/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_OwnershipInputs */

const en_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership`)
};

const es_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedad`)
};

const fr_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriété`)
};

const de_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigentumsverhältnis`)
};

const ja_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有形態`)
};

const zh_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产权性质`)
};

const ar_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الملكية`)
};

const id_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kepemilikan`)
};

const it_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Proprietà`)
};

const ru_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма собственности`)
};

const pt_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titularidade`)
};

const ko_field_ownership = /** @type {(inputs: Field_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소유권 형태`)
};

/**
* | output |
* | --- |
* | "Ownership" |
*
* @param {Field_OwnershipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_ownership = /** @type {((inputs?: Field_OwnershipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_OwnershipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_ownership(inputs)
	if (locale === "es") return es_field_ownership(inputs)
	if (locale === "fr") return fr_field_ownership(inputs)
	if (locale === "de") return de_field_ownership(inputs)
	if (locale === "ja") return ja_field_ownership(inputs)
	if (locale === "zh") return zh_field_ownership(inputs)
	if (locale === "ar") return ar_field_ownership(inputs)
	if (locale === "id") return id_field_ownership(inputs)
	if (locale === "it") return it_field_ownership(inputs)
	if (locale === "ru") return ru_field_ownership(inputs)
	if (locale === "pt") return pt_field_ownership(inputs)
	return ko_field_ownership(inputs)
});